/* SugarNova – Theme-JavaScript (ohne externe Abhängigkeiten) */
(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  var cfg = window.sugarnova || { strings: {}, cutoff: {} };
  var S = cfg.strings || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- Videos: bei reduzierter Bewegung nicht automatisch abspielen ---------- */
  $$('video[data-autoplay]').forEach(function (v) {
    if (reduceMotion) { v.removeAttribute('autoplay'); v.pause(); }
    if (v.hasAttribute('data-slowmo')) { v.playbackRate = 0.5; }
  });

  /* ---------- Mobiles Menü ---------- */
  var menuBtn = $('[data-menu-toggle]');
  var mobileNav = $('[data-mobile-nav]');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      var open = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
      $('[data-icon-open]', menuBtn).hidden = !open;
      $('[data-icon-close]', menuBtn).hidden = open;
    });
  }

  /* ---------- Suche: nach dem Öffnen fokussieren ---------- */
  var search = $('[data-search]');
  if (search) {
    search.addEventListener('toggle', function () {
      if (search.open) { var i = $('input[type="search"]', search); if (i) i.focus(); }
    });
  }

  /* ---------- Cut-off-Timer (deutsche Zeit, startet täglich neu) ---------- */
  var DAY = 86400;
  function berlinNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin', hour12: false, weekday: 'short',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    var wdMap = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
    return {
      wd: wdMap[o.weekday],
      sod: (parseInt(o.hour, 10) % 24) * 3600 + parseInt(o.minute, 10) * 60 + parseInt(o.second, 10)
    };
  }

  function cutoffState() {
    var c = cfg.cutoff || {};
    var cut = (c.hour || 15) * 3600;
    var weekends = c.weekends !== false;
    var now = berlinNow();
    function ships(wd) { return weekends || wd < 5; }
    var d = 0;
    if (!(ships(now.wd) && now.sod < cut)) {
      d = 1;
      while (!ships((now.wd + d) % 7) && d < 8) { d++; }
    }
    return {
      remaining: d * DAY + cut - now.sod,
      days: d,
      targetWd: (now.wd + d) % 7,
      hour: c.hour || 15
    };
  }

  function whenLabel(st, forCart) {
    if (st.days === 0) { return forCart ? S.todayCart : S.todayPdp; }
    if (st.days === 1) { return S.tomorrow; }
    var names = (S.days || '').split(',');
    return S.on + ' ' + (names[st.targetWd] || '');
  }

  function formatLeft(sec) {
    var h = Math.floor(sec / 3600);
    var m = Math.floor((sec % 3600) / 60);
    if (h > 0) { return (S.hm || '{h} Std. {m} Min.').replace('{h}', h).replace('{m}', m); }
    return (S.m || '{m} Min.').replace('{m}', Math.max(m, 1));
  }

  function tickCutoff() {
    var nodes = $$('[data-cutoff]');
    if (!nodes.length) return;
    var st = cutoffState();
    nodes.forEach(function (node) {
      var text = $('[data-cutoff-text]', node);
      if (node.getAttribute('data-cutoff') === 'cart') {
        if (text) text.textContent = (S.cutoffCart || '').replace('{left}', formatLeft(st.remaining)).replace('{when}', whenLabel(st, true));
      } else {
        var clock = $('[data-cutoff-clock]', node);
        if (text) text.textContent = (S.cutoffPdp || '').replace('{time}', pad(st.hour) + ':00').replace('{when}', whenLabel(st, false));
        if (clock) {
          var r = st.remaining;
          clock.textContent = pad(Math.floor(r / 3600)) + ':' + pad(Math.floor((r % 3600) / 60)) + ':' + pad(r % 60);
        }
      }
    });
  }
  tickCutoff();
  setInterval(tickCutoff, 1000);

  /* ---------- Countdown (Passwortseite) ---------- */
  function berlinToUtc(str) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(str.trim());
    if (!m) return null;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    var fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin', hour12: false, year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    function asBerlin(ts) {
      var o = {};
      fmt.formatToParts(new Date(ts)).forEach(function (p) { o[p.type] = p.value; });
      return Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute, +o.second);
    }
    return guess - (asBerlin(guess) - guess);
  }

  $$('[data-countdown]').forEach(function (box) {
    var target = berlinToUtc(box.getAttribute('data-countdown') || '');
    if (!target) { box.hidden = true; return; }
    var live = $('[data-cd-live]');
    function tick() {
      var left = Math.max(0, Math.floor((target - Date.now()) / 1000));
      var map = { d: Math.floor(left / DAY), h: Math.floor((left % DAY) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
      Object.keys(map).forEach(function (k) {
        var el = $('[data-cd="' + k + '"]', box);
        if (el) el.textContent = pad(map[k]);
      });
      if (left === 0) { box.hidden = true; if (live) live.hidden = false; return false; }
      return true;
    }
    if (tick()) {
      var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000);
    }
  });

  /* ---------- Warenkorb ---------- */
  var drawer = $('[data-drawer]');
  var lastFocus = null;

  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.classList.add('no-scroll');
    var panel = $('.drawer__panel', drawer);
    if (panel) panel.focus();
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { drawer.hidden = true; }, reduceMotion ? 0 : 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshCart() {
    return fetch(cfg.cartJsUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        return fetch(cfg.root + '?sections=cart-drawer')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data['cart-drawer'];
            if (!html) return cart;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = $('[data-cart-inner]', doc);
            var cur = $('[data-cart-inner]', drawer);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
            tickCutoff();
            return cart;
          });
      });
  }

  function onCartPage() { return document.body.classList.contains('template-cart'); }

  function afterCartChange(openIt) {
    if (onCartPage()) { window.location.reload(); return Promise.resolve(); }
    return refreshCart().then(function () { if (openIt) openDrawer(); });
  }

  function addItems(items) {
    return fetch(cfg.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw new Error(e.description || e.message || 'error'); }); }
      return r.json();
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var open = t.closest('[data-cart-open]');
    if (open && drawer && !onCartPage()) { e.preventDefault(); refreshCart().then(openDrawer); return; }

    if (t.closest('[data-drawer-close]')) { closeDrawer(); return; }

    var qty = t.closest('[data-qty-change]');
    if (qty) {
      e.preventDefault();
      fetch(cfg.cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(qty.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(qty.getAttribute('data-qty'), 10)) })
      }).then(function () { return afterCartChange(false); });
      return;
    }

    var addV = t.closest('[data-add-variant]');
    if (addV) {
      addV.disabled = true;
      addItems([{ id: parseInt(addV.getAttribute('data-add-variant'), 10), quantity: 1 }])
        .then(function () { return afterCartChange(false); })
        .catch(function () { addV.disabled = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      if (menuBtn && menuBtn.getAttribute('aria-expanded') === 'true') menuBtn.click();
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.matches('[data-gift-card]')) {
      fetch(cfg.cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Grußkarte': t.checked ? 'Ja' : '' } })
      });
    }
    if (t.matches('[data-auto-submit]') && t.form) { t.form.submit(); }
    if (t.closest('[data-filter-form]') && t.type === 'checkbox' && t.form) { t.form.submit(); }
  });

  /* Schnell-Hinzufügen (Produktkarten) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-ajax-cart')) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    if (btn) btn.disabled = true;
    var id = parseInt(form.elements.id.value, 10);
    addItems([{ id: id, quantity: 1 }])
      .then(function () { return afterCartChange(true); })
      .catch(function () {})
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- Kategorie-Chips ---------- */
  $$('[data-chips-scope]').forEach(function (scope) {
    var chips = $$('[data-chip]', scope);
    var items = $$('[data-chip-item]', scope);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var key = chip.getAttribute('data-chip');
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', String(on));
        });
        items.forEach(function (it) { it.hidden = key !== 'all' && it.getAttribute('data-chip-item') !== key; });
      });
    });
  });

  /* ---------- Mystery Boxes ---------- */
  $$('[data-mbox]').forEach(function (box) {
    var btn = $('[data-mbox-flip]', box);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var on = box.classList.toggle('is-flipped');
      btn.setAttribute('aria-pressed', String(on));
    });
  });

  /* ---------- Produktseite ---------- */
  $$('[data-product]').forEach(function (sec) {
    var form = $('[data-product-form]', sec);
    if (!form) return;
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', sec).textContent); } catch (err) { variants = []; }
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-btn]', form);
    var addLabel = $('[data-add-label]', form);
    var status = $('[data-form-status]', form);
    var qtyInput = $('[data-qty-input]', form);
    var stockWrap = $('[data-stock-wrap]', sec);
    var cutoffWrap = $('[data-cutoff-wrap]', sec);
    var sticky = $('[data-sticky-atc]', sec);
    var stickyBtn = $('[data-sticky-submit]', sec);
    var stickyLabel = $('[data-sticky-label]', sec);
    var stickyPrice = $('[data-sticky-price]', sec);
    var priceBox = $('[data-price]', sec);

    function selectedOptions() {
      return $$('fieldset[data-option-index]', form).map(function (fs) {
        var c = $('input:checked', fs); return c ? c.value : null;
      });
    }

    function setMedia(id) {
      if (!id) return;
      var items = $$('.gallery__item', sec);
      var target = items.filter(function (it) { return it.getAttribute('data-media-id') === String(id); })[0];
      if (!target) return;
      items.forEach(function (it) { it.hidden = it !== target; });
      $$('[data-thumb]', sec).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-thumb') === String(id)); });
    }

    function applyVariant(v) {
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = S.soldOut; return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? S.addToCart : S.soldOut;
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyLabel.textContent = v.available ? S.addToCart : S.soldOut; }
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (cutoffWrap) cutoffWrap.hidden = !v.available;

      if (priceBox) {
        $('[data-price-current]', priceBox).textContent = v.price;
        var cmpWrap = $('[data-price-compare-wrap]', priceBox);
        var cmp = $('[data-price-compare]', priceBox);
        var unit = $('[data-price-unit]', priceBox);
        $('[data-price-current]', priceBox).classList.toggle('is-sale', !!v.compare);
        if (cmpWrap) cmpWrap.hidden = !v.compare;
        if (cmp && v.compare) cmp.textContent = v.compare;
        if (unit) { unit.textContent = v.unit || ''; unit.hidden = !v.unit; }
      }

      if (stockWrap) {
        var st = $('[data-stock]', stockWrap);
        var tx = $('[data-stock-text]', stockWrap);
        if (st && tx) {
          st.classList.toggle('is-in', v.available);
          st.classList.toggle('is-out', !v.available);
          tx.textContent = v.available ? stockWrap.getAttribute('data-text-in') : S.soldOut;
        }
      }

      setMedia(v.media);
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    $$('fieldset[data-option-index] input', form).forEach(function (input) {
      input.addEventListener('change', function () {
        var sel = selectedOptions();
        var match = variants.filter(function (v) {
          return sel.every(function (o, i) { return v.options[i] === o; });
        })[0];
        applyVariant(match);
      });
    });

    /* Mengenstepper */
    $$('[data-qty-step]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, n + parseInt(b.getAttribute('data-qty-step'), 10));
      });
    });

    /* Galerie */
    var thumbs = $$('[data-thumb]', sec);
    if (thumbs.length) {
      var first = $$('.gallery__item', sec)[0];
      if (first) setMedia(first.getAttribute('data-media-id'));
      var initial = variants.filter(function (v) { return String(v.id) === idInput.value; })[0];
      if (initial && initial.media) setMedia(initial.media);
      thumbs.forEach(function (b) { b.addEventListener('click', function () { setMedia(b.getAttribute('data-thumb')); }); });
    }

    /* In den Warenkorb */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.disabled = true;
      addLabel.textContent = S.adding;
      status.textContent = '';
      addItems([{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }])
        .then(function () { status.textContent = S.added; return afterCartChange(true); })
        .catch(function (err) { status.textContent = (err && err.message && err.message !== 'error') ? err.message : S.error; })
        .then(function () { addBtn.disabled = false; addLabel.textContent = S.addToCart; });
    });

    /* Bundle */
    var bundle = $('[data-bundle]', sec);
    if (bundle) {
      $('[data-bundle-add]', bundle).addEventListener('click', function () {
        var btn = this;
        btn.disabled = true;
        addItems([
          { id: parseInt(idInput.value, 10), quantity: 1 },
          { id: parseInt(bundle.getAttribute('data-bundle-variant'), 10), quantity: 1 }
        ]).then(function () { return afterCartChange(true); })
          .catch(function (err) { status.textContent = (err && err.message && err.message !== 'error') ? err.message : S.error; })
          .then(function () { btn.disabled = false; });
      });
    }

    /* Mobile Kaufleiste: erscheint, wenn der Hauptbutton nicht sichtbar ist */
    if (sticky && stickyBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(addBtn);
      stickyBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  });
})();
